import { getSolveSession } from '@yandex-int/k-common/client/api';

import { useQuery } from 'react-query';

export function useCodingSolveSession(params: { problemLinkId: number | undefined; studentId: number | undefined }) {
    const { problemLinkId, studentId } = params;
    return useQuery(
        ['solveSession', problemLinkId, studentId],
        () => {
            if (problemLinkId === undefined || studentId === undefined) {
                return null;
            }
            return getSolveSession({ problemLinkId, studentId });
        },
        {
            enabled: !(problemLinkId === undefined || studentId === undefined),
        }
    );
}
